module.exports = __webpack_public_path__ + "img/bg-proplat.7e7553da.jpeg";